import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=61d15c65&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=61d15c65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d15c65",
  null
  
)

export default component.exports